module.exports = __webpack_public_path__ + "img/chl.d244e47f.svg";